import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3100";
const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function approveSale(token, saleId, attachment) {
  const body = attachment ? new FormData() : {};
  if (attachment) body.append("attachment", attachment);
  const response = await axios.post(
    `${API_URL}/api/approvals/sale/${saleId}/approve`,
    body,
    auth(token),
  );
  return response.data;
}

export async function rejectSale(token, saleId, reason) {
  const response = await axios.post(
    `${API_URL}/api/approvals/sale/${saleId}/reject`,
    { reason },
    auth(token),
  );
  return response.data;
}
